import React from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

// A toast payload must never take the app down. If anything passed to
// toast.*() is unrenderable (an object → React error #31), the crash stops
// HERE — the toaster goes quiet for that render instead of bubbling to the
// root ErrorBoundary and unmounting the entire authenticated tree.
class ToastCrashGuard extends React.Component {
  state = { crashed: false }
  static getDerivedStateFromError() { return { crashed: true } }
  componentDidCatch(err) {
    // eslint-disable-next-line no-console
    console.error("Toast payload crashed the toaster (contained):", err)
  }
  render() { return this.state.crashed ? null : this.props.children }
}

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <ToastCrashGuard>
      <Sonner
        theme={theme}
        className="toaster group"
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            description: "group-[.toast]:text-muted-foreground",
            actionButton:
              "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton:
              "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          },
        }}
        {...props} />
    </ToastCrashGuard>
  );
}

export { Toaster, toast }
